import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './videos-widget.m.css';
import VideoCardImageHeadlineAuthor from '../video-card-image-headline-author';
import ViewAll from '../../atoms/view-all';
import VideoTitle from '../titles/videos';
import { BQLink } from '../../atoms/bqlink';

const VideosWidget = ({ stories }) => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    stories
      ? setVideos(stories)
      : fetch('/api/v1/collections/in-the-news-videos')
          .then((res) => res.json())
          .then((res) => {
            setVideos(res?.items?.map((item) => item.story).slice(0, 4));
          });
  }, []);

  return videos?.length > 0 ? (
    <div styleName="videos-wrapper">
      <div styleName="videos-title" className="title-with-view-all">
        <VideoTitle />
        <ViewAll isTitle={true} />
      </div>

      <div styleName="videos">
        {videos.map((item, index) => (
          <VideoCardImageHeadlineAuthor key={index} story={item} />
        ))}
      </div>
    </div>
  ) : null;
};

VideosWidget.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object),
};

export default VideosWidget;
